var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_c('v-avatar',{attrs:{"left":"","color":"teal white--text"}},[(_vm.profilePicture)?_c('v-img',{attrs:{"src":_vm.profilePicture}}):_c('span',[_vm._v(_vm._s(_vm.initials))])],1),_vm._v(" "+_vm._s(_vm.fullname)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }